import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { TranslateService } from 'app/i18n';
import { SheetCountModal } from '../sheet-count-modal/sheet-count-modal.component';

@Component({
  selector: 'editado-sheet-qa-modal',
  templateUrl: 'editado-sheet-qa-modal.component.html',
  styleUrls:   ['editado-sheet-qa-modal.component.scss']
})
export class EditadoSheetQaModal implements OnInit, OnDestroy {
  @Input('job') job;
  @Input('order') order;
  @Input('shipment')     shipment;
  @Input('reprint') reprint;
  reprintNumber : string;
  sheetCountModalRef      : BsModalRef;
  editadoSheetCheck   : boolean = false;
  imageUrl : string = 'https://s3.amazonaws.com/impreso.sheet.asset/editado_reprint_sample.png';
  constructor(
    private translate        : TranslateService,
    private modalService     : BsModalService,
  ) {
  }
  ngAfterViewInit() {
  }
  
  ngOnInit(): void {
    console.log("EDITADO REPRINT INFO: ", this.reprint.split('|'));
    this.reprintNumber = this.reprint.split('|')[0].replace(/[^0-9]/g, "").trim();
  }

  ngOnDestroy(): void {
    console.log("destroyed")
  }

  reprintOkay() {
    // console.log(this.job)
    // console.log(this.shipment)
    this.sheetCountModalRef = this.modalService.show(SheetCountModal, {
      animated: false,
      class   : 'modal-lg sheet-count-modal',
      initialState : { job: this.job,  order: this.order, shipment: this.shipment}
    });

  }
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/modals/editado-sheet-qa-modal/editado-sheet-qa-modal.component.ts